export function isISODateStr(str: string): boolean {
	return /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d.\d{3}Z/.test(str)
}

export function dateToReadableString(date: Date | string, locale: string): string {
	if (typeof date === 'string') {
		if (!isISODateStr(date)) {
			throw new Error('Invalid date string')
		}
		date = new Date(date)
	}
	const optionsDate: Intl.DateTimeFormatOptions = {
		weekday: 'long', // "Monday"
		year: 'numeric', // "2024"
		month: 'long', // "February"
		day: 'numeric' // "18"
	}

	const optionsTime: Intl.DateTimeFormatOptions = {
		hour: '2-digit', // "09"
		minute: '2-digit', // "30"
		hour12: false // Use 24-hour time
	}

	const dateString = date.toLocaleDateString(locale, optionsDate)
	const timeString = date.toLocaleTimeString(locale, optionsTime)

	const atOrUm = locale.startsWith('de') ? 'um' : 'at'

	return `${dateString}, ${atOrUm} ${timeString}`
}

export function dateToReadableHours(date: Date): string {
	const hours = date.getHours().toString().padStart(2, '0')
	const minutes = date.getMinutes().toString().padStart(2, '0')
	return `${hours}:${minutes}`
}
